import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LoadingService } from '@core/services/loading.service';
import { BlockUIModule } from 'primeng/blockui';

@Component({
  selector: 'app-spinner',
  template: `
    @if (isLoading$ | async; as isLoading) {
      <div class="spinner__container">
        <div class="spinner__loader"></div>
      </div>
      <p-blockUI [blocked]="isLoading" />
    } @else {
      <p-blockUI [blocked]="false" />
    }
  `,
  styleUrl: './spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, BlockUIModule],
})
export class SpinnerComponent {
  private readonly _loadingService = inject(LoadingService);

  public isLoading$ = this._loadingService.loading$.asObservable();
}
